import Money from 'js-money';

/**
 * @param value Object {amount: Number, currency: String}
 */
export function createMoney(value) {
    if (null == value) {
        return null;
    }

    if (null == value.amount || null == value.currency) {
        return null;
    }

    return Money.fromInteger(value);
}

/**
 * @param value Money {amount: Number, currency: String} object
 */
export function formatCurrency(value) {
    if (null == value) {
        return '';
    }

    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value.amount / 100);
}

export function formatCurrencySplitted(value) {
    if (null == value) {
        return null;
    }


    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    });
    const currency = formatter.formatToParts(value.currency);
    const formattedValue = formatter.format(value.amount / 100);

    const parts = formattedValue.split(currency.decimal);

    return {
        intPart: parts[0],
        decimalPart: parts[1] == undefined ? '00' : parts[1],
        currency
    };
}
